/*
Names starting with _ are for "external sanity checks",
this is to prevent collision with the unit-value's @Input() name
which is used to find sanity checks from this file during validation.

External sanity checks are either unrelated to unit-value,
or may use more than just the value of the respective unit-value.
*/

export const sanityCheckValues = {
    "errors": {
        "_biogasBiomethaneRatio": {
            max: { value: 1.1 }
        },
        "bmp-uv": {
            max: { value: 1.1 }
        },
        "_combinedElectThermalEfficiency": {
            max: { value: 100 }
        },
        "PROJECT.FEEDSTOCK.BMP.YIELD_TYPES.BIOGAS": {
            max: { value: 1.1 }
        },
        "PROJECT.FEEDSTOCK.BMP.YIELD_TYPES.BIOMETHANE": {
            max: { value: 1.1 }
        }
    },
    "warnings": {
        "_biogasBiomethaneRatio": {
            max: { value: 1.1 }
        },
        "bmp-period-uv": {
            max: { value: 90 },
            min: { value: 10 }
        },
        "bmp-ch4-concentration-uv": {
            max: { value: 75 },
            min: { value: 45 }
        },
        "feedstock-ts-uv": {
            max: { value: 100 }
        },
        "feedstock-vs-uv": {
            min: { value: 60 }
        },
        "npk-nitrogen-uv": {
            max: { value: 10 }
        },
        "npk-phosphorus-uv": {
            max: { value: 5 }
        },
        "npk-potassium-uv": {
            max: { value: 10 }
        },
        "npk-ammonia-nitrogen-uv": {
            max: { value: 10 }
        },
        "chpElectricalEfficiency": {
            min: { value: 20 },
            max: { value: 42 }
        },
        "chpThermalEfficiency": {
            min: { value: 20 },
            max: { value: 50 }
        },
        "_combinedElectThermalEfficiency": {
            max: { value: 90 }
        },
        "genEfficiency": {
            min: { value: 20 },
            max: { value: 42 }
        },
        "boilerEfficiency": {
            min: { value: 50 },
            max: { value: 98 }
        },
        "upgraderMethaneRecovery": {
            min: { value: 70 }
        },
        "_olr": {
            "PROJECT.PLANT_SPEC.DIGESTER_TYPES.DRY_CONT": {
                min: { value: 4 },
                max: { value: 10 }
            },
            "PROJECT.PLANT_SPEC.DIGESTER_TYPES.WET_MIXED": {
                min: { value: 1 },
                max: { value: 5 }
            },
            "PROJECT.PLANT_SPEC.DIGESTER_TYPES.WET_LAGOON": {
                min: { value: 0 },
                max: { value: 1 }
            }
        }
    }
}
